import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match, RouteComponentProps } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields, Table } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { MenuItem, SubmenuItem, MenuIndice } from "app/features/componentes/menu/index";
import * as comps from "../items/index";

export const submenus: SubmenuItem[] = [
    {
        titulo: "Documentación",
        items: [
            {
                titulo: "Documentar",
                icon: fa("paper-plane"),
                route: "documentar",
                visible: x => x.Documentacion.VerMenu,
                render: x => <comps.DocumentacionContainer />
            }, {
                titulo: "Cotizar",
                icon: fa("usd"),
                route: "cotizar",
                visible: x => x.Cotizar.VerMenu,
                render: x => <comps.Cotizador />
            }, {
                titulo: "QR",
                icon: fa("qrcode"),
                route: "qr",
                visible: x => x.PermisosQR.VerMenu,
                render: x => <comps.QRIndex />
            }, {
                titulo: "Entrega a ocurre",
                icon: fa("asl-interpreting"),
                route: "ocurre",
                visible: x => x.EntregaOcurre.VerMenu,
                render: x => <comps.EntregaOcurre {...x} />
            }, {
                titulo: "Guias",
                icon: fa("stack-overflow"),
                route: "guias",
                visible: x => x.Guia.VerMenu,
                render: x => <comps.GuiasIndex {...x} />
            }, {
                titulo: "Documentaciones",
                icon: fa("files-o"),
                route: "documentaciones",
                visible: x => x.Documentacion.VerMenuDocumentaciones,
                render: x => <comps.DocumentacionesIndex {...x} />
            }, {
                titulo: "Turnos",
                icon: fa("hourglass"),
                route: "turnos",
                visible: x => x.Turnos.VerMenu,
                render: x => <comps.TurnoCatalogo {...x} />
            }, 
            {
                titulo: "Rastreo",
                icon: fa("globe"),
                route: "rastreo",
                visible: x => x.Rastreo.VerMenu,
                render: x => <comps.RastreoGuiasIndex {...x} />
            }, {
                titulo: "Paquetes de guías PP",
                icon: fa("cubes"),
                route: "paquetespp",
                visible: x => x.PaquetesPP.VerMenu,
                render: x => <comps.PaquetesPPIndex {...x} />
            }
        ]
    },
    {
        titulo: "Contabilidad",
        items: [
            {
                titulo: "Depositos de banco",
                icon: fa("bank"),
                route: "depositobanco",
                visible: x => x.DepositosBanco.VerMenu,
                render: x => <comps.DepositoBancoIndex {...x} />
            }, {
                titulo: "Movimientos caja",
                icon: fa("archive"),
                route: "movimientoscaja",
                visible: x => x.MovimientoCaja.VerMenu,
                render: x => <comps.MovimientoCajaViewCatalogo {...x} />
            }, {
                titulo: "Cortes diarios",
                icon: fa("stack-exchange"),
                route: "cortediario",
                visible: x => x.CorteDiario.VerMenu,
                render: x => <comps.CorteDiarioCatalogo {...x} />
            }, {
                titulo: "Pólizas contables",
                icon: fa("book"),
                route: "polizascontables",
                visible: x => x.Contabilidad.VerMenu,
                render: x => <comps.ConsultaPolizascontables {...x} />
            }, {
                titulo: "Cobranza",
                icon: fa("money"),
                route: "cobranza",
                visible: x => x.Cobranza.VerMenu,
                render: x => <comps.CobranzaIndex {...x} />
            }, {
                titulo: "Calculo de comisiones",
                icon: fa("dashcube"),
                route: "corteventas",
                visible: x => x.CorteVenta.VerMenu,
                render: x => <comps.CorteVentaIndex {...x} />
            }, {
                titulo: "Diario de ventas",
                icon: fa("shopping-bag"),
                route: "reportediarioventa",
                visible: x => x.VentaDiaria.VerMenu,
                render: x => <comps.ReporteDiarioVenta {...x} />
            },  {
                titulo: "Partidas en aclaración",
                icon: fa("circle-o"),
                route: "partidasaclaracion",
                visible: x => x.Catalogos.PartidaAclaracion.VerMenu,
                render: x => <comps.PartidaAclaracionIndex {...x} />
            }
        ]
    },
    {
        titulo: "Facturación",
        items: [
            {
                titulo: "Facturas",
                icon: fa("handshake-o"),
                route: "facturas",
                visible: x => x.Facturas.VerMenu,
                render: x => <comps.FacturaIndex {...x} />
            }, {
                titulo: "Facturar guías",
                icon: fa("bookmark-o"),
                route: "facturarguias",
                visible: x => x.Facturas.VerFacturarGuias,
                render: x => <comps.GuiasAFacturarIndex {...x} />
            }, {
                titulo: "Facturar guías de público general",
                icon: fa("bookmark"),
                route: "facturapublico",
                visible: x => x.Facturas.VerFacturarGuiasPublicoGeneral,
                render: x => <comps.FacturarGuiasPublicoGeneralIndex {...x} />
            },
        ]
    },
    {
        titulo: "Reportes",
        items: [
            {
                titulo: "Reporte consulta de guías",
                icon: fa("list-alt"),
                route: "reporteconsultaguias",
                visible: x => x.Reportes.VerReporteConsultaGuias,
                render: x => <comps.ReporteConsultaGuias {...x} />
            },
            {
                titulo: "Reporte de conteo de guías",
                icon: fa("list-ol"),
                route: "repconteo",
                visible: x => x.Reportes.VerMenuReporteConteoGuias,
                render: x => <comps.ReporteConteoGuiaEditComp {...x} />
            },
            {
                titulo: "Comportamiento comercial",
                icon: fa("houzz"),
                route: "reportecomportamientocomercial",
                visible: x => x.Reportes.VerMenuReporteComportamientoComercial,
                render: x => <comps.ReporteComportamientoComercial {...x} />
            },
            {
                titulo: "Cobranza semanal",
                icon: fa("dollar"),
                route: "reportecobranzasemanal",
                visible: x => x.Reportes.VerReporteCobranzaSemanal,
                render: x => <comps.ReporteCobranzaSemanal {...x} />
            }, {
                titulo: "Guías enviadas y recibidas",
                icon: fa("exchange"),
                route: "reporteguiasenviadasrecibidas",
                visible: x => x.Reportes.VerReporteGuiasEnviadasYRecibidas,
                render: x => <comps.ReporteGuiasEnviadasRecibidas {...x} />
            }, {
                titulo: "Seguimiento de ventas",
                icon: fa("money"),
                route: "reporteseguimientoventas",
                visible: x => x.Reportes.VerReporteSeguimientoDeVentas,
                render: x => <comps.ReporteSeguimientoVentas {...x} />
            }, {
                titulo: "Estadísticas de clientes",
                icon: fa("pie-chart"),
                route: "reporteestadisticasclientes",
                visible: x => x.Reportes.VerReporteEstadisticasClientes,
                render: x => <comps.ReporteEstadisticasClientes {...x} />
            }, {
                titulo: "Envíos por canal de comercialización",
                icon: fa("stack-exchange"),
                route: "reportecanalcomercializacion",
                visible: x => x.Reportes.VerReporteEnviosPorCanalDeComercializacion,
                render: x => <comps.EnviosCanalComercializacion {...x} />
            }, {
                titulo: "Eficiencia EAD",
                icon: fa("truck"),
                route: "reporteeficienciaead",
                visible: x => x.Reportes.VerReporteEficienciaEAD,
                render: x => <comps.EficienciaEAD {...x} />
            }, {
                titulo: "Venta de guías de PP",
                icon: fa("file"),
                route: "reporteguiaspp",
                visible: x => x.Reportes.VerReporteVentaPP,
                render: x => <comps.ReporteVentasPP {...x} />
            }, {
                titulo: "Saldos de paquetes de PP",
                icon: fa("cubes"),
                route: "reportepaquetespp",
                visible: x => x.Reportes.VerReportePaquetesPP,
                render: x => <comps.ReportePaquetesPP {...x} />
            }, {
                titulo: "Reporte de saldos de cartera / Notas de crédito",
                icon: fa("imdb"),
                route: "reportesaldocartera",
                visible: x => x.Reportes.VerReporteSaldoCartera,
                render: x => <comps.ReporteSaldosCartera {...x} />
            }, {
                titulo: "Reporte libro administración de sucursales",
                icon: fa("key"),
                route: "reportelibroadministracion",
                visible: x => x.Reportes.VerReporteLibroAdministracion,
                render: x => <comps.ReporteLibroAdministracion {...x} />
            }, {
                titulo: "Reporte de guias documentadas / inventarios", 
                icon: fa("list-alt"),
                route: "repguiasdoc",
                visible: x => x.Reportes.VerReporteGuiasDoc,
                render: x => <comps.ReporteGuiasDoc {...x} />
            }, {
                titulo: "Reporte partidas en aclaración",
                icon: fa("assistive-listening-systems"),
                route: "reportepartidasaclaracion",
                visible: x => x.Reportes.VerReportePartidasAclaracion,
                render: x => <comps.ReportePartidasAclaracion {...x} />
            },
            {
                titulo: "Antigüedad de saldos",
                icon: fa("circle-o"),
                route: "reporteantiguedadsaldos",
                visible: x => x.Reportes.VerMenuAntiguedadSaldos,
                render: x => <comps.AntiguedadSaldosIndex {...x} />
            },
            {
                titulo: "Estado de Cuenta",
                icon: fa("circle-o"),
                route: "reporteestadodecuenta",
                visible: x => x.Reportes.VerMenuEstadoCuenta,
                render: x => <comps.EstadoCuentaIndex {...x} />
            }
            
        ]
    },
    {
        titulo: "Traslados",
        items: [
            {
                titulo: "Cargas y descargas de caja de ruta",
                icon: fa("cubes"),
                route: "cargasdescargas",
                visible: x => x.CargaDescargaRuta.VerMenu,
                render: x => <comps.CargaDescargaIndex {...x} />
            },
            {
                titulo: "Movimientos de caja de ruta",
                icon: fa("arrows"),
                route: "cajasruta",
                visible: x => x.MovimientoCajaRuta.VerMenu,
                render: x => <comps.MovimientosCajaIndex />
            },
            {
                titulo: "Consulta de manifiestos de carga",
                icon: fa("list-alt"),
                route: "ConsultaManifiestosCarga",
                visible: x => x.CargaDescargaRuta.VerConsultaManifiestosCarga,
                render: x => <comps.ConsultaMovimientosCargaIndex{...x} />
            },
            {
                titulo: "Movimientos de camión de ruta",
                icon: fa("arrows-alt"),
                route: "camiones",
                visible: x => x.MovimientoCamionRuta.VerMenu,
                render: x => <comps.MovimientosCamionIndex />
            }, {
                titulo: "Enrutamiento",
                icon: fa("map-marker"),
                route: "enrutamiento",
                visible: x => x.Enrutamiento.VerMenu,
                render: x => <comps.Enrutamiento />
            }, {
                titulo: "Viajes de ruta",
                icon: fa("road"),
                route: "viajes",
                visible: x => x.ViajeRuta.VerMenu,
                render: x => <comps.ViajesIndex />
            }, {
                titulo: "Cargas/descargas de entrega a domicilio",
                icon: fa("linode"),
                route: "cargasEAD",
                visible: x => x.EntregaDomicilio.VerMenuCargaDescarga,
                render: x => <comps.CargasDescargasEADIndex {...x} />
            }, {
                titulo: "Viajes de entrega a domicilio",
                icon: fa("home"),
                route: "viajeEAD",
                visible: x => x.EntregaDomicilio.VerMenuViajes,
                render: x => <comps.ViajeEADIndex {...x} />
            }, {
                titulo: "Viaje EAD actual (app móvil)",
                icon: fa("truck"),
                route: "viajeApp",
                visible: x => x.EntregaDomicilio.VerLinkViajeAppActual,
                render: x => <comps.ViajeAppIndex {...x} />
            }, {
                titulo: "Consulta de camión de EAD",
                icon: fa("bus"),
                route: "consultaEAD",
                visible: x => x.Catalogos.CamionEAD.VerMenu,
                render: x => <comps.ConsultaCamionEAD {...x} />
            }, {
                titulo: "Manifiestos de RAD",
                icon: fa("file-text-o"),
                route: "manifiestoRAD",
                visible: x => x.ManifiestoRAD.VerMenu,
                render: x => <comps.ManifiestoRAD {...x} />
            }, {
                titulo: "Bitácora de Recolección a Domicilio",
                icon: fa("list-ul"),
                route: "bitacorarad",
                visible: x => x.BitacoraRAD.VerMenu,
                render:  x=> <comps.BitacoraRAD {... x} />
            }
        ]
    }, {
        titulo: "Zona extendida",
        items: [
            {
                titulo: "Corte de ingresos",
                icon: fa("scissors"),
                route: "corteingresosZE",
                visible: x => x.CorteIngresosZE.VerMenu,
                render: x => <comps.CorteIngresosZEIndex {...x} />
            },
            {
                titulo: "Entrega de ingresos a proveedor ZE",
                icon: fa("handshake-o"),
                route: "entregaingresoZE",
                visible: x => x.EntregaIngresosUsuarioZE.VerMenu,
                render: x => <comps.EntregaIngresoIndex {...x}
                />
            },
            {
                titulo: "Carga zona extendida",
                icon: fa("h-square"),
                route: "cargasze",
                visible: x => x.CargaZE.VerMenu,
                render: x => <comps.CargaZEIndex {...x} />
            },
            {
                titulo: "Descarga zona extendida",
                icon: fa("h-square"),
                route: "descargaze",
                visible: x => x.DescargaZE.VerMenuDescargaZE,
                render: x => <comps.DescargaZEIndex {...x} />
            },
            {
                titulo: "Resumen de chofer de zona extendida",
                icon: fa("arrow-circle-o-down"),
                route: "resumenchoferze",
                visible: x => x.ResumenChoferZE.VerMenuResumenChoferZE,
                render: x => <comps.ResumenChoferZE {...x} />
            },
            {
                titulo: "Consulta de guias en vehiculo de Zona Extendida",
                icon: fa("car"),
                route: "consultaZE",
                visible: x => x.ConsultaVehiculoZE.VerMenuConsultaVehiculoZE,
                render: x => <comps.ConsultaVehiculoZE {...x} />
            },
            {
                titulo: "Viaje ZE actual (app móvil)",
                icon: fa("ravelry"),
                route: "viajeappZE",
                visible: x => x.ZonaExtendida.VerMenuViajeZEApp,
                render: x => <comps.ViajeAppZE {...x} />
            },
            {
                titulo: "Viajes de zona extendida",
                icon: fa("universal-access"),
                route: "viajesZE",
                visible: x => x.ZonaExtendida.VerMenuViajeZE,
                render: x => <comps.ViajeZEIndex {...x} />
            },
            {
                titulo: "Entregas realizada",
                icon: fa("angle-double-right"),
                route: "entregasZERealizadas",
                visible: x => x.ZonaExtendida.VerMenuEntregasRealizadasZE,
                render: x => <comps.EntregasZERealizadasIndex {...x} />
            },
            {
                titulo: "Liberaciones de entrega",
                icon: fa("free-code-camp"),
                route: "liberacionentregasZE",
                visible: x => x.LiberacionesEntregaZE.VerMenuLiberacionesEntregaZE,
                render: x => <comps.LiberacionesZEIndex {...x} />
            },
            {
                titulo: "Actividades proveedor ZE",
                icon: fa("arrows-alt"),
                route: "actividadesusuariosze",
                visible: x => x.SaldosUsuarioZE.VerMenuSaldosUsuariosZE,
                render: x => <comps.SaldosUsuariosZEIndex {...x} />
            },
            {
                titulo: "Consulta de guías de ZE",
                icon: fa("stack-exchange"),
                route: "consultaguiasentregarze",
                visible: x => x.ZonaExtendida.VerMenuConsultaEntregasSucursalZE,
                render: x => <comps.ConsultaGuiasSucursalZEIndex {...x} />
            }
        ]
    }
];

export class MenuOperativa extends React.PureComponent<RouteComponentProps<any>> {
    render() {
        return (
            <div>
                <MenuIndice titulo="Operación" submenus={submenus} {... this.props} />
                {/* El componente de la firma remota no forma parte del menu principal: */}
                <Route path={this.props.match.url + "/firmaremota"} component={comps.FirmaRemotaIndex} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/menu/index.tsx